const { regChinese, regEng, regPure, regFirstCnMix, nameValidate } = require('./name')

module.exports = function (value, data) {
  const { passengerType, passengerFirstName = '', passengerLastName = '' } = data
  let nameValue = value
  let isSplit = false

  if (passengerFirstName || passengerLastName) {
    isSplit = true
    if (passengerLastName && !regPure.test(passengerLastName)) {
      return {
        validate: false,
        message: '姓必须同是中文或同是英文'
      }
    }

    if (passengerFirstName && !regEng.test(passengerFirstName) && !regFirstCnMix.test(passengerFirstName)) {
      return {
        validate: false,
        message: '姓名中的拼音/英文之后不能有中文或其他特殊符号'
      }
    }

    if (regEng.test(passengerLastName) && (regChinese.test(passengerFirstName) || regFirstCnMix.test(passengerFirstName))) {
      return {
        validate: false,
        message: '中文姓名为中文与拼音/英文混合时，姓必须是中文'
      }
    }
    nameValue = passengerLastName + passengerFirstName
  } else {
    // 一个输入框输入姓名时只允许中文或中文+拼音
    if (regEng.test(value)) {
      return {
        validate: false,
        message: '中文姓名仅支持中文或中文+拼音'
      }
    }
  }

  return nameValidate(nameValue, false, false, passengerType, true, isSplit)
}
